/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebCreateFolderModel,
  IWebCreateFolderRequest,
  IMappers,
  IWebCreateFolderResponse,
  IWebCreateFolderResponseError,
  TWebCreateFolderResponse,
} from './types';

const defaultConfig: TWebCreateFolderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/create-folder/',
  hostType: 'api',
} as TWebCreateFolderModel;

function createWebCreateFolderModel(parameters: IWebCreateFolderRequest): TWebCreateFolderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebCreateFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebCreateFolderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebCreateFolder<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebCreateFolderOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TWebCreateFolderResponse
> {
  const { response, statusCode } = await httpApi.fetch(createWebCreateFolderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebCreateFolderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebCreateFolderResponseError);
    }
  }

  return { response, statusCode } as TWebCreateFolderResponse;
}

export { defaultConfig, createWebCreateFolderModel, fetchWebCreateFolder };
